<template>
  <div>
    <v-card>
      <v-toolbar color="primary white--text" flat>
        <sabira_icon
          icon="warning-sign"
          class="mr-2"
          :strokewidth="3"
          fill="white"
        />
        <v-toolbar-title class="ml-1 text-wrap" style="line-height:1.3">
          Maksimalan broj faktura za besplatan račun dostignut!
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4 ma-0">
        <div
          style="display:grid;text-align:center; align-items:center;justify-content:center;"
        >
          <div class="title">
            Iskoristili ste {{ invoices_used }} od {{ max_allowed }} dozvoljenih
            faktura za besplatan SABIRA račun.
          </div>
          <div class="subtitle">
            Izvršite uplatu kako bi mogli koristiti SABIRA sljedećih mjesec dana
            bez ograničenja broja faktura.
          </div>
        </div>
      </v-card-text>
      <v-card-actions style="background:rgba(0,0,0,0.15)">
        <v-btn plain @click="close_dialog()">{{ $t("cancel") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn plain @click="process_payment()">{{ $t("buy") }}</v-btn>
      </v-card-actions>
    </v-card>
    <sabira_licence
      v-if="show_license"
      :visible="show_license"
      close="close_license"
    ></sabira_licence>
  </div>
</template>
<script>
export default {
  components: {
    sabira_licence: () => import("@/components/buy_license"),
    sabira_icon: () => import("@/components/sabira_icon"),
  },
  props: {
    payment: {
      type: String,
      default: null,
    },
    cancel: {
      type: String,
      default: null,
    },
    invoices_used: {
      type: Number,
      default: 0,
    },
    max_allowed: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show_license: false,
      is_loading: false,
    };
  },
  methods: {
    close_dialog() {
      this.$webpageEventBus.$emit(this.cancel);
      this.show_license = false;
    },
    process_payment() {
      this.show_license = true;
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("close_license", () => {
        // reload user profile
        this.$helpers
          .load_user_profile()
          .then(() => {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: "Plaćanje je obustavljeno",
              timeout: 3000,
            });
            this.$webpageEventBus.$emit("evt_close_account");
            this.close_dialog();
            this.$webpageEventBus.$emit("reload_data");
          })
          .catch((e) => {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: e.message,
              timeout: 4000,
            });
          });
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("close_license");
    },
  },
  mounted() {
    this.setup_event_listeners();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
